import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 48 48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "currentColor" }, [
      _createElementVNode("path", { d: "M24 38c-11 0-20-4-20-9v10c0 5 9 9 20 9 3 0 2.5-10 0-10z" }),
      _createElementVNode("ellipse", {
        cx: "24",
        cy: "9",
        rx: "20",
        ry: "9"
      }),
      _createElementVNode("path", { d: "M24 23c-11 0-20-4-20-9v10c0 5 9 9 20 9 2.8 0 2.8-10 0-10zM32.5 22c-.2 0-.4.1-.5.3-.1.2-.2.4-.2.6.4 2.5.6 4 .6 6.6 0 .6-.4.2-.4.2l-.3-.4c-.2-.3-.6-.3-.9 0-2.1 2.5-3.3 6.8-3.4 10.3 0 4.5 2.8 7.4 6.7 8.3.1 0 3.7-.1 3.7-.1 3.7-1.1 6.2-4.8 6.2-9.2C44 30.2 38 22 32.5 22zm6.8 19.4c-.4 2.5-2.6 4-4.7 3.5-2-.5-3.4-2.6-3.2-4.9.3-1.1.8-2.1 1.5-2.9.2-.2.4-.2.5 0l.6 1.3c.1.2.6.1.7-.1.8-1.7 1-3.7.7-5.6 0-.2.1-.4.3-.4.1 0 .2 0 .2.1 2.5 2 3.9 5.5 3.4 9z" })
    ], -1)
  ])))
}
export default { render: render }